import React, { useEffect, useState } from 'react';
import {
  Table,
  Button,
  Input,
  Select,
  Popconfirm,
  Space,
  Card,
  Flex,
} from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { BiSolidShow } from 'react-icons/bi';
import { getSearchApiIsStock } from '../../../network/appointment';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { useQuery } from '@tanstack/react-query';
const ItemListReconcillation = ({
  // itemsList,
  warehouse,
  setDataSource,
  dataSource,
  t,
  form,
}) => {
  const [count, setCount] = useState(0);
  const [searchTextItems, setSearchTextItems] = useState('');
  const { data: itemsList } = useQuery({
    queryKey: [queryKeys.getSearchApiIsStock, searchTextItems],
    queryFn: () =>
      getSearchApiIsStock({ type: 'Item', text: searchTextItems, stock: 1 }),
    keepPreviousData: true,
    enabled: searchTextItems?.length >= 3 || searchTextItems?.length === 0,
  });
  const columns = [
    {
      title: t.items,
      dataIndex: 'item_code',
      render: (text, record, index) => (
        <Select
          placeholder={t.items}
          value={
            record?.item_code
              ? {
                  key: record.item_code,
                  label: itemsList?.message?.find(
                    (i) => i.value === record.item_code
                  )?.description,
                }
              : undefined
          }
          labelInValue
          style={{ width: '200px' }}
          showSearch
          filterOption={false}
          onSearch={(value) => setSearchTextItems(value)}
          onChange={(value) => {
            const newDataSource = [...dataSource];
            newDataSource[index] = {
              ...newDataSource[index],
              item_code: value.key,
            };
            setDataSource(newDataSource);
          }}
          popupMatchSelectWidth={false}
        >
          {itemsList?.message?.map((item) => (
            <Select.Option
              key={item?.value}
              value={item?.value}
              label={item?.description}
            >
              <Flex gap={1} vertical>
                <span>{item?.value}</span>
                <span
                  className="item-description"
                  style={{ fontSize: '11px', color: 'gray' }}
                >
                  {item?.description}
                </span>
              </Flex>
            </Select.Option>
          ))}
        </Select>
      ),
    },
    {
      title: t.warehouse,
      dataIndex: 'warehouse',
      render: (text, record, index) => (
        <Select
          placeholder={t.setWarehouse}
          style={{ width: '100%' }}
          popupMatchSelectWidth={false}
          value={record?.warehouse}
          onChange={(value) => {
            const newDataSource = [...dataSource];
            newDataSource[index] = {
              ...newDataSource[index],
              warehouse: value,
            };
            setDataSource(newDataSource);
          }}
          options={warehouse?.data?.map((item) => ({
            value: item?.name,
            label: item?.warehouse_name,
          }))}
        />
      ),
    },
    {
      title: t.quantity,
      dataIndex: 'qty',
      render: (text, record, index) => (
        <Input
          placeholder={t.quantity}
          type="number"
          // value={record.amount}
          value={record.qty}
          onChange={(e) => {
            const newDataSource = [...dataSource];
            newDataSource[index] = {
              ...newDataSource[index],
              qty: e.target.value,
            };
            setDataSource(newDataSource);
          }}
          min={0}
          // style={{ width: 140 }}
          style={{ width: '100%' }}
        />
      ),
    },
    {
      title: t.valuationRate,
      dataIndex: 'valuation_rate',
      render: (text, record, index) => (
        <Input
          onChange={(e) => {
            const newDataSource = [...dataSource];
            newDataSource[index] = {
              ...newDataSource[index],
              valuation_rate: e.target.value,
            };
            setDataSource(newDataSource);
          }}
          placeholder={t.valuationRate}
          type="number"
          value={record.valuation_rate}
          min={0}
          width={100}
          // style={{ width: 120 }}
          style={{ width: '100%' }}
        />
      ),
    },
    {
      title: t.action,
      key: 'action',
      render: (text, record, index) => (
        <Space>
          <Popconfirm
            title={t.confirmDelete}
            onConfirm={() => handleDelete(record.key)}
          >
            <Button
              type="primary"
              danger
              icon={<DeleteOutlined />}
              size="small"
            />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const handleAdd = () => {
    const newData = {
      key: count,
      warehouse: form.getFieldValue('set_warehouse'),
    };
    setDataSource([...dataSource, newData]);
    setCount(count + 1);
  };

  const handleDelete = (key) => {
    const newDataSource = dataSource.filter((item) => item.key !== key);
    setDataSource(newDataSource);
  };
  return (
    <Card>
      <Table
        className="table_custom"
        dataSource={dataSource}
        columns={columns}
        pagination={{
          hideOnSinglePage: true,
        }}
        scroll={{ x: 'max-content' }}
        // className="table"
        rowKey="key"
      />
      <Button
        onClick={handleAdd}
        type="primary"
        ghost
        style={{ marginTop: '20px', borderRadius: '6px' }}
        icon={<PlusOutlined />}
        size="small"
      >
        {t.addRow}
      </Button>
    </Card>
  );
};

export default ItemListReconcillation;
